import { useParams, useNavigate } from "react-router-dom";
import Member360 from "@/components/crm/Member360";

export default function Member360Page() {
  const { userId } = useParams();
  const nav = useNavigate();
  return (
    <div className="max-w-6xl mx-auto px-6 lg:px-10 py-10" data-testid="member360-page">
      <Member360 userId={userId} onBack={() => nav(-1)} />
    </div>
  );
}
